<template>
    <app-modal-view @close="$emit('close')">
        <template #header>
            <div class="level is-mobile">
                <slot name="header-left-button"></slot>
                <slot name="header-title">
                    <p class="is-size-5 has-text-weight-bold">{{ windowTitle }}</p>
                </slot>

                <button
                    v-t="'Buttons.close'"
                    class="button is-flat is-dull-red is-inverted is-pulled-right"
                    @click="$emit('close')"
                ></button>
            </div>
        </template>
        <template #body>
            <div class="has-background-pale-grey px-4 py-4">
                <p class="has-text-centered title is-3 has-text-weight-bold">{{ contentTitle }}</p>
                <p
                    v-if="contentshortCode"
                    class="has-text-centered title is-size-5 has-text-weight-bold"
                >
                    {{$t('Share.project_code')}}
                    <span
                        class="has-text-primary is-3 has-text-weight-bold"
                    >{{ contentshortCode }}</span>
                </p>
                <div class="tile is-ancestor">
                    <div class="tile is-4 is-vertical is-parent">
                        <div class="tile is-child">
                            <figure class="image is-square">
                                <vue-qrcode ref="qrcode" :value="shareUrl" />
                            </figure>
                        </div>
                    </div>
                    <div class="tile is-parent">
                        <div class="tile is-child">
                            <slot name="content"></slot>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template #footer>
            <div class="level is-mobile">
                <div class="level-item">
                    <div class="level-left">
                        <div class="buttons">
                            <a
                                v-if="twitterShare"
                                :href="`https://twitter.com/intent/tweet?url=${shareUrl}&text=${contentTitle}&hashtags=Labylok`"
                                class="button"
                                target="_blank"
                                data-size="large"
                            >
                                <span class="icon">
                                    <i class="fab fa-twitter"></i>
                                </span>
                                <span v-t="'Share.share_on_twitter'"></span>
                            </a>
                            <button v-if="$store.getters.isAdmin && classroomShare" class="button">
                                <img
                                    class="image is-24x24"
                                    src="https://edu.google.com/images/classroom/classroom-icon/hero_logo.png"
                                />
                                <p class="pl-2">{{ $t('Share.share_on_classroom') }}</p>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="level-item"></div>
                <div class="level-item">
                    <div class="level-right">
                        <slot name="footer-right-button"></slot>
                    </div>
                </div>
            </div>
        </template>
    </app-modal-view>
</template>

<script>
import AppModalView from '@/components/AppModalView';
import VueQrcode from 'vue-qrcode';

export default {
    components: {
        AppModalView,
        VueQrcode,
    },
    props: {
        windowTitle: {
            type: String,
            default: '',
        },
        contentTitle: {
            type: String,
            default: '',
        },
        shareUrl: {
            type: String,
            default: '',
        },
        twitterShare: {
            type: Boolean,
            default: false,
        },
        classroomShare: {
            type: Boolean,
            default: false,
        },
        contentshortCode: {
            type: String,
            default: '',
        },
    },
};
</script>

<style></style>
